import styles from './duration.module.scss';
import { useState } from 'react';
import { useCourseGetRequestHook } from './../../../requestUtils';
import RightsWrapper from 'libs/webkua-lib/src/lib/rights-wrapper/rights-wrapper';
import { ValueFormatterParams } from 'ag-grid-community';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, Icon, PrimaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import CreateNewDurationDialog from './create-new-duration-dialog/create-new-duration-dialog';
import DeleteDurationDialog from './delete-duration-dialog/delete-duration-dialog';
import { IDuration } from 'libs/webkua-lib/src/lib/_models/duration';
import DurationSkeleton from './duration-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DurationProps { }

export function Duration(props: DurationProps) {
  const { t } = useTranslation();
  const { data: durations, isLoading, getData: getDurations }: { data: IDuration[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`resource/durations`, []);

  const [isNewDurationOpen, setIsNewDurationOpen] = useState(false);
  const [deleteDuration, setDeleteDuration] = useState<IDuration | undefined>(undefined);

  const toggleNewDurationOpen = () => setIsNewDurationOpen(!isNewDurationOpen);

  const openDeleteDurationDialog = (e: any) => setDeleteDuration(e.data);
  const closeDeleteDurationDialog = () => setDeleteDuration(undefined);

  const durationRenderer = (params: ValueFormatterParams) => {
    return params.data.value + ' ' + params.data.unit;
  };

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeleteDurationDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  };

  return (<>
    <RightsWrapper>
      <div className='mb-3'>
        <PrimaryButton
          variant="contained"
          onClick={toggleNewDurationOpen}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.newDuration')}
        </PrimaryButton>
      </div>
    </RightsWrapper>
    {isLoading ? <DurationSkeleton /> :
      <WebkuaTable
        data={durations}
        headers={CreateHeaders([
          textHeader("", t('standard.duration'), HeaderSizeEnum.EXTRA_LARGE, { renderer: durationRenderer }),
          textHeader("", "", HeaderSizeEnum.MEDIUM, {
            renderer: deleteRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
    {isNewDurationOpen && <CreateNewDurationDialog
      onClose={toggleNewDurationOpen}
      open={!!isNewDurationOpen}
      refreshData={getDurations}
    />}
    {deleteDuration && <DeleteDurationDialog
      onClose={closeDeleteDurationDialog}
      open={!!deleteDuration}
      refreshData={getDurations}
      durationId={deleteDuration.id}
    />}
  </>);
}

export default Duration;
